import { useState } from "react";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { addQuoteToBasket } from "@/components/TradeIn/client/addQuoteToBasket";
import { dispatchAnalyticsEvent } from "@/utils";
import { HttpResponse } from "@/components/TradeIn/client/createEnquiry";
import styles from "./AddToBasketButton.module.scss";

type Props = {
  basketApiBaseUrl: string;
  tradeInQuoteId: string;
};

export const AddToBasketButton = ({
  basketApiBaseUrl,
  tradeInQuoteId,
}: Props) => {
  const [submitting, setSubmitting] = useState(false);

  const raiseBasketQuantityUpdate = () => {
    window.dispatchEvent(
      new CustomEvent("jl-events.browser.basketQuantityUpdated"),
    );
  };

  async function handleAddToBasket() {
    setSubmitting(true);

    const response: HttpResponse = await addQuoteToBasket(
      basketApiBaseUrl,
      tradeInQuoteId,
    );

    setSubmitting(false);

    if (response.status >= 200 && response.status <= 299) {
      raiseBasketQuantityUpdate();

      window.dispatchEvent(
        new CustomEvent("ADD_TO_BASKET_ESI:SUCCESSFULLY_ADDED"),
      );

      dispatchAnalyticsEvent(
        "global.interaction",
        {
          type: "pdp",
          subType: "trade in - review your information - add quote to basket",
          additionalInfo: {},
          properties: {},
          products: [],
        },
        {},
      );
    } else {
      window.dispatchEvent(
        new CustomEvent("ADD_TO_BASKET_ESI:WARNING_OR_ERROR"),
      );

      dispatchAnalyticsEvent(
        "global.interaction",
        {
          type: "pdp",
          subType: "add quote to basket error",
          additionalInfo: {},
          properties: {},
          products: [],
        },
        {},
      );
    }
  }

  return (
    <div
      data-testid="trade-in-add-to-basket-container"
      className={styles.container}
    >
      <PrimaryButton
        id="basket:add:trade-in:button"
        data-testid="basket:add:trade-in"
        tag="button"
        type="button"
        submitting={submitting}
        onClick={handleAddToBasket}
        className={styles.button}
      >
        Add quote to basket
      </PrimaryButton>
    </div>
  );
};
